import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { combineReducers } from 'redux';
import { batching } from 'redux-batch-middleware';
import _reduce from 'lodash/reduce';
import _filter from 'lodash/filter';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
var replaceAsyncReducers = function replaceAsyncReducers(rootReducers, keys, reducer) {
  var key = keys.shift();
  if (keys.length === 0) {
    rootReducers[key] = reducer; // eslint-disable-line
    return;
  }
  if (rootReducers[key] === undefined) rootReducers[key] = {}; // eslint-disable-line
  var nextRootReducers = rootReducers[key];
  return replaceAsyncReducers(nextRootReducers, keys, reducer); // eslint-disable-line
};

var combineAsyncReducers = function combineAsyncReducers(asyncReducers) {
  if (_typeof(asyncReducers) !== 'object') return asyncReducers;
  var combineReducerObject = _reduce(asyncReducers, function (acc, value, key) {
    if (!asyncReducers[key]) return acc;
    if (_typeof(value) === 'object') {
      acc[key] = combineAsyncReducers(value); // eslint-disable-line
    } else if (typeof value === 'function') {
      acc[key] = value; // eslint-disable-line
    }

    return acc;
  }, {});
  return combineReducers(combineReducerObject);
};
export var makeRootReducer = function makeRootReducer(asyncReducers, defaultReducers) {
  var reducers = _reduce(asyncReducers, function (acc, value, key) {
    if (!asyncReducers[key]) return acc;
    acc[key] = combineAsyncReducers(value); // eslint-disable-line
    return acc;
  }, _objectSpread({}, defaultReducers));
  return batching(combineReducers(reducers));
};

/**
 * This function helps to dynamically inject reducer.
 * @param store - redux store instance
 * @param {string} key - path for injecting reducer
 * @param {string} reducer - reducer function to inject
 */
export var injectReducer = function injectReducer(store, key, reducer) {
  var keys = key.split('.');
  /**
   * Do nothing if reducer already exists in the store
   */
  if (_get(store.asyncReducers, keys) || _get(store.defaultReducers, keys)) {
    return;
  }
  replaceAsyncReducers(store.asyncReducers, keys, reducer);
  store.replaceReducer(makeRootReducer(store.asyncReducers, store.defaultReducers));
};

/**
 * This function helps to dynamically inject multiple reducers into the store.
 * @param store - redux store instance
 * @param bulkReducers - key value map of reducer's store key and the reducers themselves.
 */
export var injectReducersInBulk = function injectReducersInBulk(store) {
  var bulkReducers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT;
  var totalNumberOfReducerToBeAdded = _filter(bulkReducers, function (reducer, key) {
    var keys = key.split('.');
    if (_get(store.asyncReducers, keys) || _get(store.defaultReducers, keys)) {
      return false;
    }
    replaceAsyncReducers(store.asyncReducers, keys, reducer);
    return true;
  });
  if (_isEmpty(totalNumberOfReducerToBeAdded)) {
    return false;
  }
  store.replaceReducer(makeRootReducer(store.asyncReducers, store.defaultReducers));
  return true;
};